<template>
  <div id="app">
    <global-menu/>
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import GlobalMenu from "@/views/GlobalMenu";

export default {
  name: "app",
  components: { GlobalMenu }
};
</script>

<style lang="scss">
@import "./style/global.scss";

#app {
  padding-top: 80px;
}
</style>

<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter {
  transform: translateX(100vw);
}
.slide-leave-active {
  transform: translateX(-100vw);
}
</style>
